import * as React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { Link } from "../../Action/Link/Link";
import { noop } from "../../../../../Common/TypingUtils";

export const URL_REGEX = new RegExp(/https?:\/\/[a-zA-ZА-Яа-яёЁ\d./@:%_\+~=#?&]+/g);

function unescapeSquareBrackets(data: string): string {
    // NOTE Что происходит. В kclang markdown ссылки имеют семантику ссылок, но не поддерживают урлы. Они там свои
    // Чтобы сюда приходила ссылка там надо сделать эскейп маркдауна, написав \[link\](https://...). И сюда они приходят
    // вот так, со слешами перед квадратными скобками. Поэтому, тут мы их убираем, чтобы дальше нормально заработал маркдаун
    // Есть тест, который это фиксирует testDescriptionWithLink
    // Лучше бы конечно поточить грамматику, но мне лень и вообще какого хера так случилось
    // \[text\] -> [text]
    return data.replace(/\\+\[/g, "[").replace(/\\+]/g, "]");
}

export const LinkParserWrapper = (data: string | React.ReactNode): string | React.ReactNode => {
    if (typeof data === "string") {
        const formattedData = unescapeSquareBrackets(data);
        if (data.match(URL_REGEX) != undefined) {
            return markdownWrapper(formattedData);
        } else {
            return formattedData;
        }
    } else {
        return data;
    }
};

export const markdownWrapper = (data: string) => (
    <ReactMarkdown
        linkTarget={"_blank"}
        remarkPlugins={[remarkGfm]}
        components={{
            p: ({ node: _, ...props }) => <p style={{ margin: 0 }} {...props} />,
            a: ({ node: _, ...props }) => <Link {...props} onClick={noop} />,
        }}>
        {data}
    </ReactMarkdown>
);
